import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { Dropdown } from "../../../common_components/FormInputs";
import { truncateName } from "../../../helper/truncateName";
import { BILLING_SUMMARY_FILTERS } from "../billingSummary.constants";
/**
 * Two-tone "Label: Value" pill text — identical to the Commission Tracker header
 * dropdowns, so the two modules' filters read the same.
 */
const renderDropdownValue = (label, value) => (_jsxs("span", { children: [_jsxs("span", { style: { color: "#101828", fontWeight: 500 }, children: [label, ":"] }), " ", _jsx("span", { style: { color: "#667085" }, children: value })] }));
/**
 * The 7-dropdown filter bar, in its own card so it reads as a distinct section
 * between the summary cards and the listing.
 *
 * Every filter is the shared `Dropdown` configured exactly like the Commission
 * Tracker's header pills — leading icon, `size="sm"`, `header-dropdown` class,
 * `fullWidth={false}` and the two-tone display value — driven off the
 * `BILLING_SUMMARY_FILTERS` config, so adding or removing a filter is a data
 * change. The row wraps as the viewport narrows.
 */
const BillingSummaryFilters = ({ filters, onChange, amOptions }) => (_jsx(Box, { sx: {
        bgcolor: "#fff",
        border: "1px solid #D0D5DD",
        borderRadius: "8px",
        px: 2.5,
        py: 1.5,
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 0.75,
        // Uniform pill width so all seven line up instead of each sizing to its
        // own label. Raises the 130px floor `.header-dropdown` sets in App.css —
        // this nested selector is (0,2,0) vs that rule's (0,1,0), so it wins
        // without needing !important. Narrow enough that all 7 filters fit on
        // one row instead of "Type" wrapping to a second line.
        "& .header-dropdown": { minWidth: "120px" },
    }, children: BILLING_SUMMARY_FILTERS.map((filter) => {
        const selected = filters[filter.key];
        // Only the AM roster is loaded at runtime; the rest are fixed vocabularies.
        const options = filter.key === "am_id" ? amOptions ?? filter.options : filter.options;
        const selectedLabel = options.find((o) => o.value === selected)?.label;
        return (_jsx(Dropdown, { value: selected, onChange: (v) => onChange(filter.key, Array.isArray(v) ? v[0] ?? "" : v), options: options, placeholder: filter.placeholder, 
            // Long option labels ("No Network Connected") would stretch the pill,
            // so they're truncated the same way the tracker truncates AM names.
            displayValue: renderDropdownValue(filter.label, truncateName(selectedLabel || "All", 14)), leftIcon: filter.leftIcon, size: "sm", fullWidth: false, searchable: filter.searchable, clearable: true, 
            // Option order is authored in the config (workflow order for statuses).
            sortByLabel: false, className: "header-dropdown" }, filter.key));
    }) }));
export default BillingSummaryFilters;
